import { useNetworksStateContext } from "@l2r-front/l2r-networks"

import { documentQueryKeys } from "./queryKeys"
import { useDocumentQuery } from "./useDocumentQuery"

export function useDocumentProject(params = {}) {
    const { selectedNetwork } = useNetworksStateContext()
    const url = `projects/${selectedNetwork.slug}/`
    const queryKey = documentQueryKeys.project(params)

    return useDocumentQuery(
        url,
        queryKey,
        params,
    )
}